import type {
  ScaleConnectionType,
  ScaleFormatType,
  ScaleMeasurementMode,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const scaleCreateAtom = createMutationAtomFactory(
  'settings.scaleCreate',
  (params: {
    sidecarId: string;
    name: string;
    connectionType: ScaleConnectionType;
    tcpHost?: string;
    tcpPort?: number;
    serialPortPath?: string;
    baudRate?: number;
    dataBits?: number;
    stopBits?: string;
    parity?: string;
    scaleFormatType: ScaleFormatType;
    measurementMode: ScaleMeasurementMode;
    onDemandString?: string;
    unitOfMeasurement?: string;
    cameraId?: string;
  }) => ({
    iotScaleCreate: {
      __args: {
        input: {
          sidecarId: params.sidecarId,
          name: params.name,
          connectionType: params.connectionType,
          cameraId: params.cameraId,
          tcpHost: params.tcpHost,
          tcpPort: params.tcpPort,
          serialPortPath: params.serialPortPath,
          baudRate: params.baudRate,
          dataBits: params.dataBits,
          stopBits: params.stopBits,
          parity: params.parity,
          scaleFormatType: params.scaleFormatType,
          measurementMode: params.measurementMode,
          onDemandString: params.onDemandString,
          unitOfMeasurement: params.unitOfMeasurement,
        },
      },
      id: true,
      name: true,
      status: true,
      connectionType: true,
      scaleFormatType: true,
    },
  }),
);
